import React from 'react';
import { Button, Space, Tooltip, Popconfirm } from 'antd';
import {
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  DollarOutlined,
  RollbackOutlined,
} from '@ant-design/icons';

const ButtonFormatter = ({
  record,
  onCapture,
  onRefund,
  onView,
  onEdit,
  onDelete,
}) => {
  const isDisabled = record.status === 3 || record.status === 6;
  return (
    <Space>
      <Tooltip title="Thu tiền">
        <Button
          size="small"
          icon={<DollarOutlined />}
          onClick={() => onCapture(record)}
          disabled={isDisabled}
        />
      </Tooltip>

      <Tooltip title="Hoàn tiền toàn bộ">
        <Button
          size="small"
          icon={<RollbackOutlined />}
          onClick={() => onRefund(record)}
          disabled={isDisabled}
        />
      </Tooltip>

      <Tooltip title="Thông tin">
        <Button
          size="small"
          icon={<EyeOutlined />}
          onClick={() => onView(record)}
        />
      </Tooltip>

      <Tooltip title="Sửa">
        <Button
          size="small"
          icon={<EditOutlined />}
          onClick={() => onEdit(record)}
          disabled={isDisabled}
        />
      </Tooltip>

      <Popconfirm
        title="Xóa?"
        onConfirm={() => onDelete(record)}
        okText="OK"
        cancelText="Cancel"
        placement="topLeft"
      >
        <Tooltip title="Xóa">
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Tooltip>
      </Popconfirm>
    </Space>
  );
};
export default ButtonFormatter;
